<template>
  <v-container>
    <v-row v-if="isUnitPass" justify="center" align="center" class="text-center">
      <v-col class="mb-10 text-h4" cols="12">
        合格
      </v-col>
    </v-row>
    <v-row v-else justify="center" align="center" class="text-center">
      <v-col class="mb-10 text-h4" cols="12">
        不合格
      </v-col>
    </v-row>
    <v-row v-if="isUnitPass" justify="center" align="center" class="text-center">
      <v-col class="mb-10 text-body-1" cols="12">
        正答数：{{ correctAnswerNum }} / {{ questionNum }}
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'TestResult',
  components: {
  },
  props: {
    isUnitPass: {
      type: Boolean,
      require: true,
      default: null
    },
    correctAnswerNum: {
      type: Number,
      require: true,
      default: 0
    },
    questionNum: {
      type: Number,
      require: true,
      default: 0
    }
  },
  data () {
    return {
    }
  },
  computed: {
  },
  mounted: function () {
  },
  methods: {
  },
  head () {
    return {
    }
  }
}
</script>

<style>
</style>
